import React from "react";
import HighchartsReact from "highcharts-react-official";
import Highcharts from "highcharts";
import { thisBaseURL } from "../../utils/helper.js";
require("highcharts/modules/accessibility")(Highcharts);

function FoodSecurity({countryAnswers}){
	let defaultCountry = countryAnswers.answerKeyValues["country_code"];
	let foodAidSourceRef = countryAnswers.answerKeyValues['food_aid_shipments_sources'];
	let foodAidNotes = countryAnswers.answerKeyValues['food_aid_shipments_notes'];
	let foodAidYear = countryAnswers.answerKeyValues['food_aid_shipments_year'];
	let foodAidShipments = countryAnswers.answerKeyValues['food_aid_shipments'];
	let foodAidShipmentUnit = countryAnswers.answerKeyValues['food_aid_shipments_unit'] || 'Metric Tons';
	let array = [];
	let dataSeries = [];
	let xAxisCategories = [];
	if(foodAidShipments){
		try {
			array =  JSON.parse(foodAidShipments);
		} catch (err) {
			console.log("FoodSecurity :foodAidShipments: " +err);
		}
		dataSeries = array.map(function (obj) {
		    return [parseInt(obj["year"]),parseFloat(obj["quantity"])];
		});
		xAxisCategories = array.map(function (obj) {
		    return [parseInt(obj["year"])];
		});
	}
	let globalHungerSourceRef = countryAnswers.answerKeyValues['global_hunger_index_sources'];
	let globalHungerYear = countryAnswers.answerKeyValues['global_hunger_index_year'];
	let globalHungerNotes = countryAnswers.answerKeyValues['global_hunger_index_notes'];
	
	return(
		<div className="question-grouping" id="food_security">
			<h2>Food Security</h2>
			<h3>
				Global Hunger Index
				{globalHungerYear ? 
				<small>&nbsp;({globalHungerYear})</small>
				: ""}
				{globalHungerSourceRef && globalHungerSourceRef >0 ? 
				<small className="superscript"><a href={thisBaseURL +"/countries/" + defaultCountry +"#"+globalHungerSourceRef}>{globalHungerSourceRef}</a></small>
				:""}
			</h3>
			<p>{countryAnswers.answerKeyValues['global_hunger_index']}</p>
			{globalHungerNotes ? 
			<p className="notes-info" style={{marginTop:"auto"}} >
				<em>{globalHungerNotes}</em>
			</p>
			: ""}

			{(dataSeries && dataSeries.length >0) ? 
			(<><h2 style={{fontSize: "17px", color: "#333", fontWeight: "normal", textAlign: "center", fontFamily: "Lucida Grande, Lucida Sans Unicode, Arial, Helvetica, sans-serif"}}>
				Food Aid Shipments
				{foodAidYear ? 
				<small>&nbsp;({foodAidYear})</small>
				: ""}
				{foodAidSourceRef && foodAidSourceRef >0 ? 
				<small className="superscript"><a href={thisBaseURL +"/countries/" + defaultCountry +"#"+foodAidSourceRef}>{foodAidSourceRef}</a></small>
				:""}
			</h2>
			<HighchartsReact highcharts={Highcharts} containerProps={{ style: { width: "60vw" } }}
			options={{
				title: {
					text: ''
				},
				credits: {
					enabled: false
				},
				lang: {
					thousandsSep: ','
				},
				yAxis: {
					title: {
						text: foodAidShipmentUnit
					},
					plotLines: [{
						value: 0,
						width: 1,
						color: '#808080'
					}]
				},
				xAxis: {
					categories: xAxisCategories,
					title: {
						text: 'Year'
					}
				},
				legend: {
					enabled: false,
					layout: 'vertical',
					align: 'right',
					verticalAlign: 'middle',
					borderWidth: 0
				},
				series: [{
					name: foodAidShipmentUnit,
					data: dataSeries
				}]
			}}
			/>
			{foodAidNotes ? 
			<p className="notes-info" style={{marginTop:"auto"}} >
				<em>{foodAidNotes}</em>
			</p>
			: ""}
			</>) : ""}
		</div>
		)
}
export default FoodSecurity;